module.exports = __webpack_public_path__ + "img/bg_2.2d0c8b37.png";